import { CBCS } from './CBCS.js';
import { CENC } from './CENC.js';
import { KEYIDS } from './KEYIDS.js';
import { WEBM } from './WEBM.js';
/**
 * Initialization Data Type.
 *
 * @group DRM
 *
 * @beta
 */
export const InitializationDataType = {
    CENC: CENC,
    CBCS: CBCS,
    KEYIDS: KEYIDS,
    WEBM: WEBM,
};
//# sourceMappingURL=InitializationDataType.js.map